import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { refreshFavoritesFromAPI } from '../services/favorites';

const FavoritesContext = createContext();

export const FavoritesProvider = ({ children }) => {
  const [favorites, setFavorites] = useState([]);

  useEffect(() => {
    const stored = localStorage.getItem('beezy-favorites');
    if (stored) {
      setFavorites(JSON.parse(stored));
    }

    // Refresh popularity data from API
    refreshFavoritesFromAPI().then((updated) => {
      if (updated.length > 0) setFavorites(updated);
    });
  }, []);

  const addFavorite = (place) => {
    setFavorites((prev) => {
      const newFavorites = [...prev, place];
      localStorage.setItem('beezy-favorites', JSON.stringify(newFavorites));
      return newFavorites;
    });
  };

  const removeFavorite = (place) => {
    setFavorites((prev) => {
      const newFavorites = prev.filter((f) => f.place_id !== place.place_id);
      localStorage.setItem('beezy-favorites', JSON.stringify(newFavorites));
      return newFavorites;
    });
  };

  const isFavorite = (placeId) => {
    return favorites.some((f) => f.place_id === placeId);
  };

  const refreshFavorites = useCallback(() => {
    const stored = localStorage.getItem('beezy-favorites');
    if (stored) {
      setFavorites(JSON.parse(stored));
    }

    refreshFavoritesFromAPI().then((updated) => {
      if (updated.length > 0) setFavorites(updated);
    });
  }, []);

  return (
    <FavoritesContext.Provider
      value={{ favorites, addFavorite, removeFavorite, isFavorite, refreshFavorites }}
    >
      {children}
    </FavoritesContext.Provider>
  );
};

FavoritesProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useFavorites = () => {
  const context = useContext(FavoritesContext);
  if (!context) {
    throw new Error('useFavorites must be used within a FavoritesProvider');
  }
  return context;
};
